import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  ViewChildren,
} from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppData } from "src/app/helpers/app-data";
import { BaseServiceService } from "src/app/services/base-service.service";
import { Subscription } from "rxjs";
import { emptyArray } from "@microsoft/fast-element";

@Component({
  selector: "app-data-table",
  templateUrl: "./data-table.component.html",
  styleUrl: "./data-table.component.css",
})
export class DataTableComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() tableId: string;
  @Input() buttonsOptions: any = [];
  @Input() serverSide: boolean;
  @Input() localData: any = [];
  @Input() serverData: any = [];
  @Input() columns: any = [];
  @Input() customColumns: any = [];
  @Input() isExcludedData: string;
  @Input() isNotifyData?: boolean;

  @Output() custom?: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadedGrid: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren(DataTableDirective) dtElement: QueryList<DataTableDirective>;
  dtOptions: DataTables.Settings = {};
  dtInstance: any;
  paramToken;
  usuariosExcluidos;
  rolesExcluidos;
  gruposExcluidos;

  private currentIdsUsuariosExcluidosSubscription: Subscription;
  private currentIdsRolesExcluidosSubscription: Subscription;
  private currentIdsgruposExcluidosSubscription: Subscription;

  constructor(
    private renderer: Renderer2,
    private http: HttpClient,
    private baseService: BaseServiceService
  ) {}

  ngOnInit() {
    this.paramToken = this.baseService.getParamValue("Token");

    const headers = new HttpHeaders({
      "X-APIKey": AppData.API_KEY,
      Authorization: "Bearer " + this.paramToken,
    });

    this.currentIdsUsuariosExcluidosSubscription =
      this.baseService.currentIdsExcluidosUsuarios.subscribe((ids) => {
        this.usuariosExcluidos = ids;
      });

    this.currentIdsRolesExcluidosSubscription =
      this.baseService.currentIdsExcluidosRoles.subscribe((ids) => {
        this.rolesExcluidos = ids;
      });

    this.currentIdsgruposExcluidosSubscription =
      this.baseService.currentIdsExcluidosGrupos.subscribe((ids) => {
        this.gruposExcluidos = ids;
      });

    if (this.isNotifyData) {
      this.dtOptions = {
        pagingType: "full_numbers",
        //pageLength: 5,
        serverSide: this.serverSide,
        processing: true,
        searching: true,
        ordering: true,
        language: {
          url: "../../../assets/es-ES.json",
        },
        columns: [...this.columns],
        order: this.getInitialOrder(), // Establece el orden inicial basado en las columnas
        //lengthMenu: [5], // Ocultar la opción de cambiar la cantidad de registros a mostrar
        scrollY: "30vh", // Altura de la barra de desplazamiento
        scrollCollapse: true, // Colapsa la tabla si hay pocas filas
      };
    } else {
      this.dtOptions = {
        pagingType: "full_numbers",
        pageLength: 10,
        serverSide: this.serverSide,
        processing: true,
        searching: true,
        ordering: true,
        language: {
          url: "../../../assets/es-ES.json",
        },
        columns: [...this.columns],
        order: this.getInitialOrder(), // Establece el orden inicial basado en las columnas
      };
    }

    if (this.isExcludedData) {
      var serverMethod = this.serverData.join("/");

      this.dtOptions.ajax = async (dataTablesParameters: any, callback) => {
        let excluidos;
        
        switch (this.isExcludedData) {
          case "usuarios":
            
            excluidos = this.usuariosExcluidos;
            break;
          case "roles":
            
            excluidos = this.rolesExcluidos;
            break;
          case "grupos":
            
            excluidos = this.gruposExcluidos;
            break;
        }
        console.log(this.usuariosExcluidos);
        if (!excluidos) {
          excluidos = emptyArray;
        }
        
        this.http
          .post<any>(
            AppData.API_URL + serverMethod,
            {
              DataTableRequest: dataTablesParameters,
              excludeIds: excluidos,
            },
            {
              headers: headers,
            }
          )
          .subscribe((resp) => {
            if (resp.Data.data[0].Estado) {
              const dataWithEstadoText = resp.Data.data.map((item: any) => {
                return {
                  ...item,
                  Estado: this.getEstadoText(item.Estado),
                };
              });

              callback({
                draw: resp.Data.draw,
                recordsTotal: resp.Data.recordsTotal,
                recordsFiltered: resp.Data.recordsFiltered,
                data: dataWithEstadoText,
              });
            } else {
              callback({
                draw: resp.Data.draw,
                recordsTotal: resp.Data.recordsTotal,
                recordsFiltered: resp.Data.recordsFiltered,
                data: resp.Data.data,
              });
            }
          });
      };
    }

    if (this.serverSide && !this.isExcludedData) {
      var serverMethod = this.serverData.join("/");

      this.dtOptions.ajax = async (dataTablesParameters: any, callback) => {
        this.http
          .post<any>(AppData.API_URL + serverMethod, dataTablesParameters)
          .subscribe(
            (resp) => {
              if (resp && resp.Data && Array.isArray(resp.Data.data)) {
                if (
                  resp.Data.data[0] &&
                  resp.Data.data[0].hasOwnProperty("Estado")
                ) {
                  const dataWithEstadoText = resp.Data.data.map((item: any) => {
                    return {
                      ...item,
                      Estado: this.getEstadoText(item.Estado),
                    };
                  });

                  callback({
                    draw: resp.Data.draw,
                    recordsTotal: resp.Data.recordsTotal,
                    recordsFiltered: resp.Data.recordsFiltered,
                    data: dataWithEstadoText,
                  });
                } else {
                  callback({
                    draw: resp.Data.draw,
                    recordsTotal: resp.Data.recordsTotal,
                    recordsFiltered: resp.Data.recordsFiltered,
                    data: resp.Data.data,
                  });
                }
              } else {
                console.error("Respuesta inválida del servidor");
                callback({
                  draw: 0,
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            },
            (error) => {
              console.error("Error en la llamada HTTP", error);
              callback({
                draw: 0,
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
            }
          );
      };
    } else {
      if (this.localData.length > 0) this.dtOptions.data = this.localData;
    }

    if (this.customColumns.length > 0) {
      this.customColumns.forEach((col) => {
        var element = ``;
        var customColumn = {
          title: col["title"],
          data: "Id",
          orderable: false,
          render: (data: any, type: any, full: any) => {
            buttons = ``;

            var elementData = full[col["propertyData"]];
            var columnValue = "";

            switch (col["dataType"]) {
              case "json":
                elementData = JSON.parse(elementData);
                columnValue = elementData[col["data"]];
                break;
            }

            switch (col["columnType"]) {
              case "icon":
                element = `<i class="sidenav-link-icon ms-Icon ${columnValue}" style=" font-size: large; "></i>`;
                break;
            }

            return element;
          },
        };

        if (customColumn) this.dtOptions.columns.splice(0, 0, customColumn);
      });
    }

    if (this.buttonsOptions.length > 0) {
      var buttons = ``;
      var options = {
        title: "Opciones",
        data: "Id",
        orderable: false,
        render: (data: any, type: any, full: any) => {
          buttons = ``;

          this.buttonsOptions.forEach((button) => {
            var renderButton = true;

            if (button["conditional-column"]) {
              var value;

              switch (button["conditional-datatype"]) {
                case "boolean":
                  value = Boolean(button["conditional-value"]);
                  break;
                case "string":
                  value = button["conditional-value"].toString();
                  break;
                case "int":
                  value = parseInt(button["conditional-value"]);
                  break;
              }

              var columnValue = full[button["conditional-column"]];

              switch (button["conditional-comparison"]) {
                case "equals":
                  renderButton = columnValue === value;
                  break;
                case "not-equals":
                  renderButton = columnValue !== value;
                  break;
                case "not":
                  renderButton = !columnValue;
                  break;

                default:
                  renderButton = false;
              }
            }

            if (renderButton) {
              var additionalData = ``;

              if (button["conditional-data"]) {
                button["conditional-data"].forEach((condData) => {
                  additionalData += ` data-${condData.key}="${
                    full[condData.value]
                  }"`;
                });
              }

              var buttonHide = ``;

              if (button["button-hide"]) {
                buttonHide = ` style='display:none'`;
              }

              buttons += `<button class="ms-CommandButton-button opt-button" id="${
                button["button-id"]
              }" 
              data-id="${full.Id}" button-id="${
                button["button-id"]
              }"${additionalData}${buttonHide}
              title="${button["button-tooltip"]}">
              <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="${
                "ms-Icon " + button["button-icon"]
              }"></i></span>
              </button>`;
            }
          });

          return buttons;
        },
      };

      if (options) this.dtOptions.columns.push(options);
    }
  }

  getInitialOrder() {
    // Establece el orden inicial de las columnas
    const order = [];
    this.columns.forEach((column, index) => {
      if (column.order) {
        // Si la columna tiene la propiedad `order`, añade la configuración de orden
        order.push([index, column.order]);
      }
      // else {
      //   // Si no tiene la propiedad `order`, establece el orden ascendente por defecto
      //   order.push([index, 'asc']);
      // }
    });
    return order;
  }

  ngAfterViewInit() {
    this.GetDataTabledtInstance(this.dtElement, this.tableId).then(
      (dtInstance) => {
        this.dtInstance = dtInstance;
        this.loadedGrid.emit({ tableId: this.tableId, table: this.dtInstance });
        dtInstance.on("draw", () => {
          this.attachClickEvents();
        });
      }
    );
  }
  ngOnDestroy() {
    if (this.currentIdsUsuariosExcluidosSubscription) {
      this.currentIdsUsuariosExcluidosSubscription.unsubscribe();
    }
    if (this.currentIdsRolesExcluidosSubscription) {
      this.currentIdsRolesExcluidosSubscription.unsubscribe();
    }
    if (this.currentIdsgruposExcluidosSubscription) {
      this.currentIdsgruposExcluidosSubscription.unsubscribe();
    }
  }

  attachClickEvents(): void {
    const optButtons = document.querySelectorAll(".opt-button");

    optButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const buttonId = button.getAttribute("button-id");
        const dataId = button.getAttribute("data-id");

        // Crear un objeto para almacenar los atributos condicionales
        let conditionalData = {};

        // Obtener todos los atributos "data-*"
        button.getAttributeNames().forEach((attrName) => {
          if (
            attrName.startsWith("data-") &&
            attrName !== "data-id" &&
            attrName !== "button-id"
          ) {
            conditionalData[attrName] = button.getAttribute(attrName);
          }
        });

        // Emitir el evento si se está observando
        if (this.custom.observed) {
          this.custom.emit({
            event: event,
            table: this.dtInstance,
            "table-id": this.tableId,
            "data-id": dataId,
            "button-id": buttonId,
            ...conditionalData, // Incluye los atributos condicionales en el objeto emitido
          });
        }
      });
    });
  }

  public ReloadGrid(dtElements: any, controlName: string) {
    try {
      if (dtElements instanceof QueryList) {
        dtElements.forEach((dtElement: DataTableDirective, index: number) => {
          dtElement.dtInstance.then((dtInstance: any) => {
            if (!controlName || dtInstance.table().node().id == controlName) {
              dtInstance.search("").draw();
              dtInstance.ajax.reload();
            }
          });
        });
      } else {
        dtElements.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.ajax.reload();
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  public GetDataTabledtInstance(
    dtElements: any,
    controlName: string
  ): Promise<any> {
    const that = this;
    return new Promise((resolve, rejection) => {
      try {
        if (dtElements instanceof QueryList) {
          dtElements.forEach((dtElement: DataTableDirective, index: number) => {
            dtElement.dtInstance.then((dtInstance: any) => {
              if (dtInstance.table().node().id == controlName)
                resolve(dtInstance);
            });
          });
        } else {
          dtElements.dtInstance.then((dtInstance: DataTables.Api) => {
            resolve(dtInstance);
          });
        }
      } catch (error) {
        console.log(error);
      }
    });
  }

  getEstadoText(estado: number) {
    switch (estado) {
      case 1:
        return "Diseño";

      case 2:
        return "Pruebas";

      case 3:
        return "Produccion";

      default:
        break;
    }
  }
}
